<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import Stocks from './components/Stocks.vue'

export default {
  name: 'App',
  components: {
    // Stocks
  },
  created () {
    // console.log("this: ", this)
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*color: #2c3e50;*/
}
</style>
